import * as React from 'react'
import Icon from './icon'

const TemplateIcon = ({
  icon,
  shadow = true,
  shadowLarge,
  border,
  wrapperLarge,
  iconLarge,
  className,
}) => {
  const shadowClassName = shadowLarge ? 'shadow-2xl' : 'shadow-hard'

  const iconWrapperClassBase = [
    'flex items-center justify-center rounded-full bg-white',
    shadow ? shadowClassName : '',
    border ? 'border-2 border-gray-900' : '',
    wrapperLarge ? 'p-3 md:p-6' : 'p-3',
    className,
  ]

  const iconWh = iconLarge ? 'w-6 h-6 sm:w-10 sm:h-10 lg:w-20 lg:h-20' : 'w-6 h-6 sm:w-10 sm:h-10'

  return (
    <div className={iconWrapperClassBase.join(' ')}>
      <Icon icon={icon} size={96} wh={iconWh} />
    </div>
  )
}

export default TemplateIcon
